import {
  PROFILE_TEAMS,
  EDIT_TEAMS,
  ADD_TEAM,
  DELETE_TEAM,
} from "../actions/types";

const initialState = [];

function initTeams(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case PROFILE_TEAMS:
      return payload;

    case EDIT_TEAMS:
      return state.map((team) =>
        team.id === payload.id ? { ...team, ...payload } : team
      );

    case ADD_TEAM:
      return [...state, payload];

    case DELETE_TEAM:
      return state.filter((team) => team.id !== payload.id);

    default:
      return state;
  }
}

export default initTeams;
